import React from 'react';
import { string, number, func } from 'prop-types';
import classNames from 'classnames';
import createFragment from 'react-addons-create-fragment';
import Icon from 'components/icon';
import PageView from './PageView';
import BreakView from './BreakView';

export default class Pagination extends React.Component {
    constructor(props) {
        super(props);

        const forceSelected = props.forceSelected ? props.forceSelected : 0;
        this.state = {
            selected: props.initialSelected
                ? props.initialSelected
                : forceSelected
        };

        this.handlePreviousPage = this.handlePreviousPage.bind(this);
        this.handleNextPage = this.handleNextPage.bind(this);
        this.handlePageSelected = this.handlePageSelected.bind(this);
        this.callCallback = this.callCallback.bind(this);
        this.pagination = this.pagination.bind(this);

        // Create event binding for lopped elements.
        this.pageSelectedEvent = [];
        for (let index = 0; index < this.props.pageNum; index += 1) {
            this.pageSelectedEvent[index] = this.handlePageSelected.bind(
                this,
                index
            );
        }
    }

    componentDidMount() {
        // Call the callback with the initialSelected item:
        if (typeof this.props.initialSelected !== 'undefined') {
            this.callCallback(this.props.initialSelected);
        }
    }

    shouldComponentUpdate(newProps) {
        return (
            this.props.forceSelected !== newProps.forceSelected ||
            this.props.pageNum !== newProps.pageNum
        );
    }

    /* eslint-disable-next-line camelcase */
    UNSAFE_componentWillUpdate(nextProps) {
        this.pageSelectedEvent = [];
        for (let index = 0; index < nextProps.pageNum; index += 1) {
            this.pageSelectedEvent[index] = this.handlePageSelected.bind(
                this,
                index
            );
        }
    }

    /* eslint-disable-next-line camelcase */
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (
            typeof nextProps.forceSelected !== 'undefined' &&
            this.props.forceSelected !== nextProps.forceSelected
        ) {
            this.setState({ selected: nextProps.forceSelected });
        }
    }

    handlePreviousPage(evt) {
        evt.preventDefault();
        evt.stopPropagation();
        if (this.state.selected > 0) {
            this.handlePageSelected(this.state.selected - 1, evt);
        }
    }

    handleNextPage(evt) {
        evt.preventDefault();
        evt.stopPropagation();
        if (this.state.selected < this.props.pageNum - 1) {
            this.handlePageSelected(this.state.selected + 1, evt);
        }
    }

    handlePageSelected(selected, evt) {
        evt.preventDefault();
        evt.stopPropagation();

        if (this.state.selected === selected) return;

        this.setState({ selected });

        // Call the callback with the new selected item:
        this.callCallback(selected);

        // Animate to top of listing
        const filters = document.querySelector('.c-lzone-breadcrumbs');
        filters.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    callCallback(selectedItem) {
        if (
            typeof this.props.clickCallback !== 'undefined' &&
            typeof this.props.clickCallback === 'function'
        ) {
            this.props.clickCallback({ selected: selectedItem });
        }
    }

    pagination() {
        const items = {};
        let itemClassName;

        if (this.props.pageNum <= this.props.pageRangeDisplayed) {
            for (let index = 0; index < this.props.pageNum; index += 1) {
                itemClassName = this.props.pageClassName;
                if (
                    index >= this.state.selected - 1 &&
                    index <= this.state.selected + 1
                ) {
                    itemClassName = `${itemClassName} mobile-view`;
                }

                items[`key${index}`] = (
                    <PageView
                        onClick={this.pageSelectedEvent[index]}
                        selected={this.state.selected === index}
                        pageClassName={itemClassName}
                        pageLinkClassName={this.props.pageLinkClassName}
                        activeClassName={this.props.activeClassName}
                        page={index + 1}
                    />
                );
            }
        } else {
            let leftSide = this.props.pageRangeDisplayed / 2;
            let rightSide = this.props.pageRangeDisplayed - leftSide;

            if (
                this.state.selected >
                this.props.pageNum - this.props.pageRangeDisplayed / 2
            ) {
                rightSide = this.props.pageNum - this.state.selected;
                leftSide = this.props.pageRangeDisplayed - rightSide;
            } else if (
                this.state.selected <
                this.props.pageRangeDisplayed / 2
            ) {
                leftSide = this.state.selected;
                rightSide = this.props.pageRangeDisplayed - leftSide;
            }

            let page;
            let breakView;

            for (let index = 0; index < this.props.pageNum; index += 1) {
                itemClassName = this.props.pageClassName;
                if (
                    index >= this.state.selected - 1 &&
                    index <= this.state.selected + 1
                ) {
                    itemClassName = `${itemClassName} mobile-view`;
                }

                page = index + 1;

                const pageView = (
                    <PageView
                        onClick={this.pageSelectedEvent[index]}
                        selected={this.state.selected === index}
                        pageClassName={itemClassName}
                        pageLinkClassName={this.props.pageLinkClassName}
                        activeClassName={this.props.activeClassName}
                        page={index + 1}
                    />
                );

                if (page <= this.props.marginPagesDisplayed) {
                    items[`key${index}`] = pageView;
                } else if (
                    page >
                    this.props.pageNum - this.props.marginPagesDisplayed
                ) {
                    items[`key${index}`] = pageView;
                } else if (
                    index >= this.state.selected - leftSide &&
                    index <= this.state.selected + rightSide
                ) {
                    items[`key${index}`] = pageView;
                } else {
                    const keys = Object.keys(items);
                    const breakLabelKey = keys[keys.length - 1];
                    const breakLabelValue = items[breakLabelKey];

                    if (
                        this.props.breakLabel &&
                        breakLabelValue !== breakView
                    ) {
                        breakView = (
                            <BreakView
                                breakLabel={this.props.breakLabel}
                                breakClassName={this.props.breakClassName}
                            />
                        );

                        items[`key${index}`] = breakView;
                    }
                }
            }
        }

        return items;
    }

    render() {
        const disabled = this.props.disabledClassName;

        const previousClasses = classNames(this.props.previousClassName, {
            [disabled]: this.state.selected === 0
        });

        const nextClasses = classNames(this.props.nextClassName, {
            [disabled]: this.state.selected === this.props.pageNum - 1
        });

        return (
            <nav className={`${this.props.containerClassName} c-r-pagination`}>
                <ul className="c-pagination__list">
                    <li className={`${previousClasses} c-r-pagination__item`}>
                        <button
                            onClick={this.handlePreviousPage}
                            onKeyPress={this.handlePreviousPage}
                            className={this.props.previousLinkClassName}
                        >
                            <Icon glyph={this.props.prevIcon} />
                            <span className="hidden">
                                {this.props.previousLabel}
                            </span>
                        </button>
                    </li>

                    {createFragment(this.pagination())}

                    <li className={`${nextClasses} c-r-pagination__item`}>
                        <button
                            onClick={this.handleNextPage}
                            onKeyPress={this.handleNextPage}
                            className={this.props.nextLinkClassName}
                        >
                            <span className="hidden">
                                {this.props.nextLabel}
                            </span>
                            <Icon glyph={this.props.nextIcon} />
                        </button>
                    </li>
                </ul>
            </nav>
        );
    }
}

Pagination.propTypes = {
    /* eslint-disable react/no-typos */
    // The disable is needed until https://github.com/yannickcr/eslint-plugin-react/issues/1389 is resolved
    pageNum: number.isRequired,
    pageRangeDisplayed: number.isRequired,
    marginPagesDisplayed: number.isRequired,
    previousLabel: string,
    nextLabel: string,
    breakLabel: string,
    clickCallback: func,
    initialSelected: number,
    forceSelected: number,
    containerClassName: string,
    pageClassName: string,
    pageLinkClassName: string,
    activeClassName: string,
    previousClassName: string,
    nextClassName: string,
    previousLinkClassName: string,
    nextLinkClassName: string,
    disabledClassName: string,
    breakClassName: string,
    prevIcon: string,
    nextIcon: string
    /* eslint-enable react/no-typos */
};

Pagination.defaultProps = {
    activeClassName: 'selected',
    previousClassName: 'previous',
    nextClassName: 'next',
    previousLabel: 'Previous',
    nextLabel: 'Next',
    breakLabel: '...',
    disabledClassName: 'disabled',
    clickCallback: () => {},
    initialSelected: 1,
    forceSelected: 1,
    containerClassName: 'c-pagination',
    pageClassName: 'page',
    pageLinkClassName: '',
    previousLinkClassName: '',
    nextLinkClassName: '',
    breakClassName: 'c-pagination__item c-pagination__item--dots',
    prevIcon: 'arrow-drop-left',
    nextIcon: 'arrow-drop-right'
};
